"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AuthProvider_1 = require("../components/AuthProvider");
const Login = () => {
    const { login } = (0, AuthProvider_1.useAuth)();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null, "Login"),
        react_1.default.createElement("button", { onClick: login }, "Login")));
};
exports.default = Login;
